(function($){

	$(document).ready(function(){
		//$(".sticky_prepared.live_stuck .al_center .logo-main").removeClass("col-lg-12");
      
     // $('h3.product-title a:contains("|")').css('font-size': '12px');
      
     
      
     //$( "h3.product-title a:contains('|')" ).css( "text-decoration", "underline" );

      
		//$(".al_center .logo-main").addClass("col-lg-2");
      
      var grp_icn = $('.grp_icons').hasClass('dn');
      $(window).scroll(function() {
          if ($(this).scrollTop() >= 40){  
            $('.al_center .logo-main').addClass("col-lg-2");
            $('.al_center .logo-main').removeClass("col-lg-12");
            if(grp_icn){
              $('.grp_icons').addClass('col-lg-auto col-md-4 col-3 tr col_group_btns');
              $('.grp_icons').removeClass('dn');
            }
            $('.ntheader_wrapper').addClass('sticky');
          }
          else{
            $('.al_center .logo-main').removeClass("col-lg-2");
            $('.al_center .logo-main').addClass("col-lg-12");
            if(grp_icn){
              $('.grp_icons').removeClass('col-lg-auto col-md-4 col-3 tr col_group_btns');
              $('.grp_icons').addClass('dn');
            }
            $('.ntheader_wrapper').removeClass('sticky');
          }
      });

	});


})(jQuery)